import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store/index';

@(Module({ dynamic: true, store, name: 'overlay', namespaced: true }) as unknown as (target: new (...args: unknown[]) => VuexModule) => void)
class OverlayModule extends VuexModule {
  isVisible = false;

  @Mutation
  public setVisible(value: boolean) {
    this.isVisible = value;
  }
}

export const overlayModule = getModule(OverlayModule);
